/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateImportGroupRequest
 */
export interface CreateImportGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateImportGroupRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImportGroupRequest
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateImportGroupRequest interface.
 */
export function instanceOfCreateImportGroupRequest(value: object): value is CreateImportGroupRequest {
    return true;
}

export function CreateImportGroupRequestFromJSON(json: any): CreateImportGroupRequest {
    return CreateImportGroupRequestFromJSONTyped(json, false);
}

export function CreateImportGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateImportGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateImportGroupRequestToJSON(json: any): CreateImportGroupRequest {
    return CreateImportGroupRequestToJSONTyped(json, false);
}

export function CreateImportGroupRequestToJSONTyped(value?: CreateImportGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

